export default __webpack_public_path__ + "static/media/173.45f411bb.jpg";